import { rgba } from 'polished';
import { pxToRem } from 'modules/spacing';
import { swatches } from '../colors';
const TOKEN = swatches.warm[1000];
export const dropShadow = {
    '100': `0 ${pxToRem(2)} ${pxToRem(2)} ${rgba(TOKEN, 0.04)}, 0 0 ${pxToRem(2)} ${rgba(TOKEN, 0.04)}`,
    '200': `0 ${pxToRem(1)} ${pxToRem(2)} ${rgba(TOKEN, 0.3)}, 0 ${pxToRem(2)} ${pxToRem(6)} ${rgba(TOKEN, 0.15)}`,
    '300': `0 ${pxToRem(8)} ${pxToRem(20)} ${rgba(TOKEN, 0.08)}, 0 ${pxToRem(4)} ${pxToRem(18)} ${rgba(TOKEN, 0.04)}`,
    '400': `0 ${pxToRem(6)} ${pxToRem(18)} ${rgba(TOKEN, 0.12)}, 0 ${pxToRem(14)} ${pxToRem(20)} ${rgba(TOKEN, 0.16)}`,
};
